// src/models/Invader.js

class Invader {
    constructor(id, position, status, instagramUrl, captured, value = -1, captureSource = null, imageUrl = null) {
        this.id = id;
        this.position = position; // [latitude, longitude]
        this.status = status; // 'ok' ou 'not-ok'
        this.instagramUrl = instagramUrl;
        this.captured = captured;
        this.value = value; // points de l'invader (-1 = inconnu)
        this.captureSource = captureSource; // 'LOCAL' ou 'FLASH_INVADERS'
        this.imageUrl = imageUrl; // image officielle (notre stockage)
    }

    needsValue() {
        return this.value === null || this.value < 0;
    }

    // flashable
    isOk() {
        return this.status === 'OK' && !this.isCaptured();
    }

    isCaptured() {
        return this.captured;
    }

    isFlashInvadersCapture() {
        return this.captureSource === 'FLASH_INVADERS';
    }

    canBeUncaptured() {
        return this.isCaptured() && !this.isFlashInvadersCapture();
    }

    updateStatus(newStatus) {
        this.status = newStatus;
    }

    getDescription() {
        return `Invader ${this.id}: ${this.instagramUrl} (Statut : ${this.status})`;
    }
}

export default Invader;